import { FeatureToggleClientService } from 'feature-toggle-client';
export const attendanceRulesBuilder = 'attendance-rules-in-builder';
export const queueManagementInBuilder = 'queue-management-in-builder';
export class BuilderAttendanceRulesSidebarFeatures {
    static attendanceRulesBuilderEnabled() {
        return FeatureToggleClientService.getInstance().isFeatureEnabled(attendanceRulesBuilder);
    }
    static queueManagementInBuilderEnabled() {
        return FeatureToggleClientService.getInstance().isFeatureEnabled(queueManagementInBuilder);
    }
}
